<template>
  <div class="title-div">
    <div class="title">
      <h2>{{ title }}</h2>
      <slot name="default" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseFormTitle',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="less">
.title-div{
  position: relative;
  .title{
    &::before{
      display: inline-block;
      position: absolute;
      content: "";
      top: 4px;
      left: 0;
      width: 4px;
      background: #20bf64;
      height: 16px;
    }
    h2{
      display: inline-block;
      padding-left: 8px;
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Layout/blockLayout.vue?df0b2a60